import {Backbone} from 'Vertebrae';
import {File} from '../model/file';

export const Files = Backbone.Collection.extend({
    _name: 'Files',
    model: File,
});
